import React from 'react'
import styled from 'styled-components'
import {injectIntl} from 'react-intl'
import TextField from '@mui/material/TextField'
import {getIcons} from 'utils/utils'

const Icons = styled.div`
    overflow: auto;
    height: 225px;
    margin-bottom: 10px;
    background: rgba(202, 220, 224, 0.1);
    border-radius: 4px;
    padding: 10px;
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
`

const Item = styled.div`
    border: ${props => props.border ? '2px dotted #cadce0' : ''};
    transform: ${props => props.border ? 'scale(1.25)' : ''};
`

const Field = styled(TextField)`
    width: 100%;
    margin-bottom: 20px;
`

const IconsList = ({icon, intl, onClick}) => {
    const [pattern, setPattern] = React.useState('')

    const filterIcons = (e) => {
        setPattern(e.target.value)
    }

    const icons = getIcons(pattern)

    return (
        <React.Fragment>
            <Field
				variant="standard"
                onChange={filterIcons}
                label={intl.formatMessage({id: "main.module_search_icon"})}
                InputLabelProps={{
                    shrink: true
                }}
            />
            <Icons>
                {icons.map((item, index) =>
                    <Item
                        onClick={() => onClick(item)}
                        value={item}
                        key={index}
                        className={"entity-icon entity-icon-" + item}
                        border={icon === item}
                    />
                )}
            </Icons>
        </React.Fragment>
    )
}

export default injectIntl(IconsList)
